import React from "react";
import { withRouter } from "react-router-dom";

const NotFound = (props) => {
  let getReturn = () => {
    return (
      <h2
        style={{
          height: "calc(100vh - 75px)",
          width: "100vw",
          color: "#2A3F54",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        404|NOT FOUND
      </h2>
    );
  };

  return getReturn();
};

export default withRouter(NotFound);
